import React from 'react';

import { ua, generateDeepLink } from '@mssgme/helpers';
import { CardMessengers, MessengerButton } from '@mssgme/cards';

const MESSENGERS = [
    {
        messenger: 'telegram',
        name: 'mssgmebot',
        redirectUrl: 'https://mssg.me/r/m/5e5fb1e519a0b30013ae1d81',
    },
    {
        messenger: 'viber',
        name: 'mssgmesupport',
        redirectUrl: 'https://mssg.me/r/m/5c157205409b90000aa4f611',
        type: 'public',
    },
    {
        messenger: 'messenger',
        name: 'mssg.me',
        redirectUrl: 'https://mssg.me/r/m/618271a1a43f580040c07e3e',
    },
    {
        messenger: 'vk',
        name: 'mssgmeapp',
        redirectUrl: 'https://mssg.me/r/m/61530428b28e45001fcab76e',
    },
    {
        messenger: 'whatsapp',
        name: '380508450362',
        redirectUrl: 'https://mssg.me/r/m/5f338f6b7a03670028138cca',
    },
];

export default function Help() {
    const mesProps = MESSENGERS.map((m) => ({
        platform: m.messenger,
        href: ua.isMobile ? generateDeepLink(m).getUrl() : m.redirectUrl,
    }));

    return (
        <>
            <CardMessengers>
                {mesProps.map(({ platform, ...rest }) => (
                    <MessengerButton key={platform} platform={platform} data-messenger={platform} {...rest} />
                ))}
            </CardMessengers>
        </>
    );
}
